export const VITE_AUTH0_DOMAIN: string = import.meta.env.VITE_AUTH0_DOMAIN;
export const VITE_AUTH0_AUDIENCE: string = import.meta.env.VITE_AUTH0_AUDIENCE;
export const VITE_AUTH0_CLIENT_ID: string = import.meta.env
  .VITE_AUTH0_CLIENT_ID;
export const VITE_AUTH0_PROFILE: string = import.meta.env.VITE_AUTH0_PROFILE;
export const VITE_CLIENT_ID: string = import.meta.env.VITE_CLIENT_ID;
export const VITE_CSV_BOX: string = import.meta.env.VITE_CSV_BOX;
export const VITE_INDUCTION_URL: string = import.meta.env.VITE_INDUCTION_URL;
export const VITE_ISSUER_BASE_URL: string = import.meta.env
  .VITE_ISSUER_BASE_URL;
export const VITE_LASTMILE_URL: string = import.meta.env.VITE_LASTMILE_URL;
export const VITE_MAPTILER_API_KEY: string = import.meta.env
  .VITE_MAPTILER_API_KEY;
export const VITE_PERMISSIONS_FRONT: string = import.meta.env
  .VITE_PERMISSIONS_FRONT;
export const VITE_REDIRECT_URL: string = import.meta.env.VITE_REDIRECT_URL;
export const VITE_NAMESPACE: string = 'https://oauth.99minutos.com/';
export const VITE_AUTH0_NAMESPACE: string = 'https://oauth.99minutos.com/';
